export const getPageLink = (path: string): string | undefined => {
  if (path) {
    return stripPrefix(path);
  }
  return undefined;
};
